/**
 * @generated SignedSource<<9f67e33a92d89c6ba37d49c891ac6ca8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useHasMinterRole_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePersistedWalletAddress_viewer">;
  readonly " $fragmentType": "useHasMinterRole_viewer";
};
export type useHasMinterRole_viewer$key = {
  readonly " $data"?: useHasMinterRole_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHasMinterRole_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHasMinterRole_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fetchUser",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "userId",
          "value": ""
        }
      ],
      "kind": "FragmentSpread",
      "name": "usePersistedWalletAddress_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e0b88feb3a804f64edfe05aecfa456b2";

export default node;
